(function () {
  'use strict';

  function setItemState(item, isOpen) {
    var toggle = item.querySelector('[data-sd-faq-toggle]');
    var panel = item.querySelector('[data-sd-faq-panel]');

    if (!toggle || !panel) {
      return;
    }

    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    item.classList.toggle('is-open', isOpen);
  }

  function initFaqSection(section) {
    if (!section || section.dataset.sdFaqInitialized === 'true') {
      return;
    }

    section.dataset.sdFaqInitialized = 'true';

    var items = section.querySelectorAll('[data-sd-faq-item]');

    items.forEach(function (item) {
      var toggle = item.querySelector('[data-sd-faq-toggle]');
      var panel = item.querySelector('[data-sd-faq-panel]');

      if (!toggle || !panel) {
        return;
      }

      setItemState(item, false);

      toggle.addEventListener('click', function () {
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        setItemState(item, !isOpen);
      });
    });
  }

  function initAllFaqSections(root) {
    var scope = root || document;
    scope.querySelectorAll('.sd-faq').forEach(initFaqSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllFaqSections();
    });
  } else {
    initAllFaqSections();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllFaqSections(event.target);
  });
})();
